import { getData, postData, putData, deleteData } from 'src/api/http.service';
import { ApiCallFailedAction, ApiCallInProgress, ApiCallSuccessAction } from './uistate.action';
import { getAPIEndpoints, handleApiError, handleApiSuccess } from 'src/utils/general.utils';
import {
  generateUserInfoHeader,
  handlePlainApiSuccess,
  getDataFromSessionStorage,
} from 'src/utils';

export const PublisherActionTypes = {
  GET_CATALOGUE_LIST: '[API] : Get all catalogue.',

  GET_CURRENT_CATALOGUE_SUBJECTS: '[API] : Get current catalogue subjects.',
  GET_CATALOGUE_SUBJECTS: '[API] : Get catalogue subjects.',

  SET_CURRENT_CATALOGUE_ID: '[UI] : Setting current catalogue Id.',

  GET_CURRENT_CATALOGUE_ID_DATA: '[API] : Getting current catalogue Id data.',
  SET_CURRENT_CATALOGUEID_PAYLOAD: '[UI] : Set initial catalogueID data payload.',
  FLUSH_CURRENT_CATALOGUE_STATE: '[UI] : Flush state for current catalogue.',

  GET_CATEGORY_LIST: '[API] : Get all categories.',

  // MODIFY_CATALOGUE_SUBSCRIPTION: "[UI] : Add or edit a subscription to the payload model.",
  MODIFY_CATALOGUE_CATALOGUEINFO: '[UI] : Add catalogueInfo to payload model.',
  MODIFY_CATALOGUE_THEME: '[UI] : Add or edit color to the payload model',
  MODIFY_CATALOGUE_PUBLISHER: '[UI] : Add or edit publisher payload model',
  MODIFY_CURRENT_CATALOGUE_SUBJECTS: '[UI] : Add or remove subjects from current catalogue.',
  MODIFY_CURRENT_CATALOGUE_STAKEHOLDERS: '[UI] : Add or remove stakeholders from catalogue',
  // MODIFY_CURRENT_CATALOGUE_ADDONS: "[UI] : Add or remove add-ons from current catalogue.",
  MODIFY_CURRENT_CATALOGUE_FORM_SUBMIT: '[UI] : Update form submit state to current catalogue',

  ADD_STEPPER_ERRORS: '[UI] : Add errors to state',

  DELETE_CATALOGUE_BY_ID: '[API] : Delete catalogue by id.',
  DELETE_CATEGORY_BY_ID: '[API] : Delete category by id.',
  ADD_OR_UPDATE_CATEGORY: '[API] : Add  or update a category.',
  ADD_CATEGORY: '[API] : Add category.',

  // [New Actions]

  MODIFY_STUDENT_RESOURCE: '[UI] : Add or remove a student resource.',
  MODIFY_CTALOGUE_SUBJECT_LIST: '[UI] : Add or remove subjects from catalogue subject list.',

  SAVE_CATALOGUE: '[API] : Save the catalogue.',
  UPDATE_CATALOGUE: '[API] : Update the catalogue.',

  ADD_USERID: '[UI] : Add userId to payload.',
  UPDATE_CATALOGUE_STATUS: '[API] : Update catalogue styatus archive/unarchive.',

  // [Store Manager]

  //Recommended Courses
  GET_ALL_RECOMMENDED_COURSES: 'GET_ALL_RECOMMENDED_COURSES',
  SAVE_ALL_RECOMMENDED_COURSES: 'SAVE_ALL_RECOMMENDED_COURSES',
  SAVE_RECOMMENDED_COURSES: 'SAVE_RECOMMENDED_COURSES',

  GET_ALL_STORE_LISTING: '[API] : Get all store listing.',
  DELETE_A_STORE_LISTING: '[API] : Delete a store listing.',
  UPDATE_STORE_LISTING_STATUS: '[API] : Update store listing status archive/revert.',
  GET_STORE_LISTING_BY_ID: '[API] : Get store listing by ID.',
  GENERATE_CURRENT_STORE_LISTING_PAYLOAD: '[UI] : Generate current store listing payload.',
  FLUSH_CURRENT_STORE_LISTING_STATE: '[UI] : FLush state for current store listing payload.',
  ADD_CREATED_BY_TO_STORE_LISTING: '[UI] : Add created by to store listing payload.',

  ADD_STORE_LISTING_STEPPER_ERRORS: '[UI] : Add Store Listing errors to state',

  MODIFY_STORE_LISTING_STOREINFO: '[UI] : Add Store Listing Info to payload model.',
  MODIFY_CURRENT_STORE_LISTING_SUBSCRIPTION: '[UI] : Add or remove store listing subscription(s).',
  MODIFY_CURRENT_STORE_LISTING_ADDONS: '[UI] : Add or remove store listing addOns.',
  MODIFY_CURRENT_STORE_LISTING_PREVIEW_VIDEOS: '[UI] : Add or remove store listing Preview Videos.',
  MODIFY_CURRENT_STORE_LISTING_CATALOGUE: '[UI] : Change store listing Catalogues.',
  MODIFY_CURRENT_STORE_LISTING_NAME: '[UI] : Change store listing Name.',
  MODIFY_CURRENT_STORE_LISTING_CODE: '[UI] : Change store listing Code.',
  MODIFY_CURRENT_STORE_LISTING_SALES_IDENTIFIER: '[UI]: Change store listing sales identifier',
  MODIFY_CURRENT_STORE_LISTING_DISPLAY_NAME: '[UI] : Change store listing display name.',
  MODIFY_CURRENT_STORE_LISTING_DESCRIPTION: '[UI] : Change store listing Description.',
  MODIFY_CURRENT_STORE_STUDENT_TARGET_YEAR: '[UI] : Change student target year.',
  MODIFY_CURRENT_STORE_LISTING_SYLLABUS: '[UI] : Change store listing Syllabus.',
  MODIFY_CURRENT_STORE_LISTING_PROGRAMS: '[UI] : Change store listing Programs.',
  MODIFY_CURRENT_STORE_LISTING_EXAM_PATTERN: '[UI] : Change store listing exam pattern.',
  MODIFY_CURRENT_STORE_LISTING_PREPARATION_TIPS:
    '[UI] : Change store listing exam preparation tips.',
  MODIFY_CURRENT_STORE_LISTING_STORE_ICON: '[UI] : Change store icon.',
  MODIFY_CURRENT_STORE_LISTING_STORE_IMAGE: '[UI] : Change store image.',
  MODIFY_CURRENT_STORE_LISTING_HOURS: '[UI] : Change store listing Hours.',
  MODIFY_CURRENT_STORE_LISTING_FEATURED_ON_LEADS: '[UI] : Update Featured on Leads',
  MODIFY_CURRENT_STORE_LISTING_CATEGORY: '[UI] : Change store listing Category.',
  MODIFY_CURRENT_STORE_LISTING_SUBCATEGORY: '[UI] : Change store listing Sub-Category.',
  MODIFY_CURRENT_STORE_LISTING_STUDENT_TARGET_YEAR: '[UI] : Change store listing studentTargetYear',
  MODIFY_CURRENT_STORE_LISTING_FRESH_SALES_TAGS: '[UI] : Change store listing fresh sales tags.',
  MATCH_CURRENT_STORE_LISTING_AND_CATALOGUE_NAME: '[UI] : Make Listing name same as catalog name',
  MATCH_CURRENT_STORE_LISTING_AND_CATALOGUE_HOURS: '[UI] : Make Listing name same as catalog hours',
  MODIFY_CURRENT_STORE_LISTING_FREE_TRIAL_STATUS: '[UI] : Change free trial status',
  FLUSH_CURRENT_STORE_LISTING_ERRORS: '[UI] : Reset Listing errors',
  MODIFY_CURRENT_STORE_LISTING_HALL_TICKET_COLLECTION_DETAILS:
    '[UI] : Change Hall Ticket Collection Details',

  UPDATE_STORE_LISTING: '[API] : Update Store Listing',
  CREATE_STORE_LISTING: '[API] : Create Store Listing.',

  MODIFY_TESTIMONIAL: '[API] : Add a testimonial for store listing.',
  MODIFY_FAQ: '[API] : Modify FAQ for store listing.',
  MODIFY_QUESTION_PAPER: '[API] : Modify question paper for store listing.',
  MODIFY_SEO_RELATED_INFO: '[API] : MODIFY Seo Related Info for store listing.',

  UPDATE_CATEGORY_ORDER: '[API] : [STORE MANAGER] : Update category order.',
  UPDATE_SUBCATEGORY_ORDER: '[API] : [STORE MANAGER] : Update subcategory order.',
  UPDATE_STORELISTING_ORDER: '[API] : [STORE MANAGER] : Update store listing order.',

  SET_SELECTED_CATEGORY: '[UI] : [STORE MANAGER] : Set selected category.',
  SET_SELECTED_SUBCATEGORY: '[UI] : [STORE MANAGER] : Set selected subcategory.',
  SET_STORE_LISTINGS:
    '[UI] : [STORE MANAGER] : Set store listings of selected category=> selected subscategory.',

  // [Ots Manager]

  GET_ALL_OTS_CATALOGUE: '[API] : Get all ots catalogue list.',
  GENERATE_CURRENT_OTS_SUBSCRIPTION_LIST: '[API] : Generate current OTS Subscription List',
  FLUSH_CURRENT_OTS_SUBSCRIPTION_LIST: '[UI] : Flush current OTS Subscription List',
  MODIFY_PRODUCT_TO_SUBSCRIPTION_BY_ID: '[UI]: Modify product to subscription',
  ADD_PRODUCT_TO_SUBSCRIPTION_BY_ID: '[UI]: Add product to subscription',
  DELETE_PRODUCT_TO_SUBSCRIPTION_BY_ID: '[UI]: Delete product From subscription',
  UPDATE_PRODUCT_IN_SUBSCRIPTION_BY_ID: '[UI]: Update product Inside subscription',
  DISCARD_CHANGES_IN_SUBSCRIPTION_BY_ID: '[UI]: Discard Changes in ots List',
  UPDATE_OTS_SUBSCRIPTION: '[UI]: Save Subscription to Ots List',
  GET_ALL_LIVE_BATCHES: 'GET_ALL_LIVE_BATCHES_ACTIVE',
  GET_BATCHES_PAGINATED: '[API] : Get batches with search and pagination.',
  GET_ALL_FEATURES: '[API] : Get all features',
};

// Plain Actions *********************************************************************************

// [Ots Manager]

export function GetOtsCatalogueListSuccessAction(payload) {
  return {
    type: PublisherActionTypes.GET_ALL_OTS_CATALOGUE,
    payload: payload,
  };
}

export function InitOtsSubscriptionsListAction(payload) {
  return {
    type: PublisherActionTypes.GENERATE_CURRENT_OTS_SUBSCRIPTION_LIST,
    payload: payload,
  };
}

export function FlushOtsSubscriptionListingByIDAction() {
  return {
    type: PublisherActionTypes.FLUSH_CURRENT_OTS_SUBSCRIPTION_LIST,
  };
}

export function ModifyProductToSubscription(payload) {
  return {
    type: PublisherActionTypes.MODIFY_PRODUCT_TO_SUBSCRIPTION_BY_ID,
    payload: payload,
  };
}

export function AddProductToSubscription(payload) {
  return {
    type: PublisherActionTypes.ADD_PRODUCT_TO_SUBSCRIPTION_BY_ID,
    payload: payload,
  };
}

export function DeleteProductToSubscription(payload) {
  return {
    type: PublisherActionTypes.DELETE_PRODUCT_TO_SUBSCRIPTION_BY_ID,
    payload: payload,
  };
}

export function UpdateProductInSubscription(payload) {
  return {
    type: PublisherActionTypes.UPDATE_PRODUCT_IN_SUBSCRIPTION_BY_ID,
    payload: payload,
  };
}

export function DiscardChangesInSubscription(payload) {
  return {
    type: PublisherActionTypes.DISCARD_CHANGES_IN_SUBSCRIPTION_BY_ID,
    payload: payload,
  };
}

export function UpdateOtsSubscriptionSuccessAction(payload) {
  return {
    type: PublisherActionTypes.UPDATE_OTS_SUBSCRIPTION,
    payload: payload,
  };
}

// [Store Manager]

export function UpdateSubCategoryOrderSuccessAction(payload) {
  return {
    type: PublisherActionTypes.UPDATE_SUBCATEGORY_ORDER,
    payload: payload,
  };
}

export function UpdateStoreListingOrderSuccessAction(payload) {
  return {
    type: PublisherActionTypes.UPDATE_STORELISTING_ORDER,
    payload: payload,
  };
}

export function SetStoreListingsSuccessAction(payload) {
  return {
    type: PublisherActionTypes.SET_STORE_LISTINGS,
    payload: payload,
  };
}

export function SetSelectedCategorySuccessAction(payload) {
  return {
    type: PublisherActionTypes.SET_SELECTED_CATEGORY,
    payload: payload,
  };
}

export function SetSelectedSubCategorySuccessAction(payload) {
  return {
    type: PublisherActionTypes.SET_SELECTED_SUBCATEGORY,
    payload: payload,
  };
}

export function UpdateCategoryOrderSuccessAction(payload) {
  return {
    type: PublisherActionTypes.UPDATE_CATEGORY_ORDER,
    payload: payload,
  };
}

export function ModifyTestimonialAction(payload) {
  return {
    type: PublisherActionTypes.MODIFY_TESTIMONIAL,
    payload: payload,
  };
}

export function ModifyFaqAction(payload) {
  return {
    type: PublisherActionTypes.MODIFY_FAQ,
    payload: payload,
  };
}

export function ModifyQuestionPaperAction(payload) {
  return {
    type: PublisherActionTypes.MODIFY_QUESTION_PAPER,
    payload: payload,
  };
}

export function ModifySeoInfoRelatedAction(payload) {
  return {
    type: PublisherActionTypes.MODIFY_SEO_RELATED_INFO,
    payload: payload,
  };
}

export function CreateStoreListingSuccessAction(payload) {
  return {
    type: PublisherActionTypes.CREATE_STORE_LISTING,
    payload: payload,
  };
}

export function UpdateStoreListingSuccessAction(payload) {
  return {
    type: PublisherActionTypes.UPDATE_STORE_LISTING,
    payload: payload,
  };
}

export function ModifyCurrentStoreListingSubscriptionAction(payload) {
  return {
    type: PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_SUBSCRIPTION,
    payload: payload,
  };
}

export function ModifyCurrentStoreListingAddOnsAction(payload) {
  return {
    type: PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_ADDONS,
    payload: payload,
  };
}

export function ModifyCurrentStoreListingPreviewVideosAction(payload) {
  return {
    type: PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_PREVIEW_VIDEOS,
    payload: payload,
  };
}

export function ModifyCurrentStoreListingCatalogueAction(payload) {
  return {
    type: PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_CATALOGUE,
    payload: payload,
  };
}

export function ModifyCurrentStoreInfo(payload) {
  return {
    type: PublisherActionTypes.MODIFY_STORE_LISTING_STOREINFO,
    payload: payload,
  };
}

export function AddStoreListingStepperError(payload) {
  return {
    type: PublisherActionTypes.ADD_STORE_LISTING_STEPPER_ERRORS,
    payload: payload,
  };
}

export function ModifyCurrentStoreListingNameAction(payload) {
  return {
    type: PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_NAME,
    payload: payload,
  };
}
export function ModifyCurrentStoreListingCodeAction(payload) {
  return {
    type: PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_CODE,
    payload: payload,
  };
}

export function ModifyCurrentStoreListingSalesIdentifier(payload) {
  return {
    type: PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_SALES_IDENTIFIER,
    payload: payload,
  };
}
export function ModifyCurrentStoreListingDisplayName(payload) {
  return {
    type: PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_DISPLAY_NAME,
    payload: payload,
  };
}

export function ModifyCurrentStoreListingDescriptionAction(payload) {
  return {
    type: PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_DESCRIPTION,
    payload: payload,
  };
}

export function ModifyCurrentStoreStudentTargetYearAction(payload) {
  return {
    type: PublisherActionTypes.MODIFY_CURRENT_STORE_STUDENT_TARGET_YEAR,
    payload: payload,
  };
}

export function ModifyCurrentStoreListingSyllabusUrlAction(payload) {
  return {
    type: PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_SYLLABUS,
    payload: payload,
  };
}
export function ModifyCurrentStoreListingFreshSaleTagsAction(payload) {
  return {
    type: PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_FRESH_SALES_TAGS,
    payload,
  };
}
export function ModifyCurrentStoreListingProgramsAction(payload) {
  return {
    type: PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_PROGRAMS,
    payload: payload,
  };
}

export function ModifyCurrentStoreListingStoreIconUrlAction(payload) {
  return {
    type: PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_STORE_ICON,
    payload: payload,
  };
}
export function ModifyCurrentStoreListingStoreImageUrlAction(payload) {
  return {
    type: PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_STORE_IMAGE,
    payload: payload,
  };
}
export function ModifyCurrentStoreListingExamPatterAction(payload) {
  return {
    type: PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_EXAM_PATTERN,
    payload: payload,
  };
}
export function ModifyCurrentStoreListingPreparationTipsAction(payload) {
  return {
    type: PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_PREPARATION_TIPS,
    payload: payload,
  };
}
export function ModifyCurrentStoreListingHoursAction(payload) {
  return {
    type: PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_HOURS,
    payload: payload,
  };
}

export function ModifyCurrentStoreListingFeaturedOnLeadsAction(payload) {
  return {
    type: PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_FEATURED_ON_LEADS,
    payload: payload,
  };
}
export function ModifyCurrentStoreListingCategoryAction(payload) {
  return {
    type: PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_CATEGORY,
    payload: payload,
  };
}
export function ModifyCurrentStoreListingSubCategoryAction(payload) {
  return {
    type: PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_SUBCATEGORY,
    payload: payload,
  };
}

export function ModifyCurrentStoreListingStudentTargetYearAction(payload) {
  return {
    type: PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_STUDENT_TARGET_YEAR,
    payload: payload,
  };
}

export function MatchCurrentStoreListingAndCatalogueName(payload) {
  return {
    type: PublisherActionTypes.MATCH_CURRENT_STORE_LISTING_AND_CATALOGUE_NAME,
    payload: payload,
  };
}

export function MatchCurrentStoreListingAndCatalogueHours(payload) {
  return {
    type: PublisherActionTypes.MATCH_CURRENT_STORE_LISTING_AND_CATALOGUE_HOURS,
    payload: payload,
  };
}

export function AddCreatedByToStoreListingPayloadAction(payload) {
  return {
    type: PublisherActionTypes.ADD_CREATED_BY_TO_STORE_LISTING,
    payload: payload,
  };
}

export function FlushCurrentStoreListingPayloadAction(payload) {
  return {
    type: PublisherActionTypes.FLUSH_CURRENT_STORE_LISTING_STATE,
    payload: payload,
  };
}

export function InitStoreListingPayloadAction(payload) {
  return {
    type: PublisherActionTypes.GENERATE_CURRENT_STORE_LISTING_PAYLOAD,
    payload: payload,
  };
}

export function GetStoreListingByIDSuccessAction(payload) {
  return {
    type: PublisherActionTypes.GET_STORE_LISTING_BY_ID,
    payload: payload,
  };
}

export function GetAllStoreListingSuccessAction(payload) {
  return {
    type: PublisherActionTypes.GET_ALL_STORE_LISTING,
    payload: payload,
  };
}

export function DeleteAStoreListingSuccessAction(payload) {
  return {
    type: PublisherActionTypes.DELETE_A_STORE_LISTING,
    payload: payload,
  };
}

export function UpdateStoreListingStatusSuccessAction(payload) {
  return {
    type: PublisherActionTypes.UPDATE_STORE_LISTING_STATUS,
    payload: payload,
  };
}

export function FlushCurrentStoreListingErrorsAction(payload) {
  return {
    type: PublisherActionTypes.FLUSH_CURRENT_STORE_LISTING_ERRORS,
    payload: payload,
  };
}

// [Catalogue Manager]
export function UpdateCatalogueStatusSuccessAction(payload) {
  return {
    type: PublisherActionTypes.UPDATE_CATALOGUE_STATUS,
    payload: payload,
  };
}

export function AddUserIDToPayloadAction(payload) {
  return {
    type: PublisherActionTypes.ADD_USERID,
    payload: payload,
  };
}

export function ModifyCatalogueSubjectListAction(payload) {
  return {
    type: PublisherActionTypes.MODIFY_CTALOGUE_SUBJECT_LIST,
    payload: payload,
  };
}

export function ModifyStudentResourceAction(payload) {
  return {
    type: PublisherActionTypes.MODIFY_STUDENT_RESOURCE,
    payload: payload,
  };
}

//

export function AddCategorySuccessAction(payload) {
  return {
    type: PublisherActionTypes.ADD_CATEGORY,
    payload: payload,
  };
}

export function UpdateCatagorySuccessAction(payload) {
  return {
    type: PublisherActionTypes.ADD_OR_UPDATE_CATEGORY,
    payload: payload,
  };
}

export function DeleteCategoryByIdSuccessAction(payload) {
  return {
    type: PublisherActionTypes.DELETE_CATEGORY_BY_ID,
    payload: payload,
  };
}

export function DeleteCatalogueByIdSuccessAction(payload) {
  return {
    type: PublisherActionTypes.DELETE_CATALOGUE_BY_ID,
    payload: payload,
  };
}

// export function ModifyCurrentCatalogueAddOns(payload){
//     return {
//         type: PublisherActionTypes.MODIFY_CURRENT_CATALOGUE_ADDONS,
//         payload: payload
//     }
// }

export function ModifyCurrentCatalogueSubjects(payload) {
  return {
    type: PublisherActionTypes.MODIFY_CURRENT_CATALOGUE_SUBJECTS,
    payload: payload,
  };
}

export function FlushCurrentCatalogueStateAction(payload) {
  return {
    type: PublisherActionTypes.FLUSH_CURRENT_CATALOGUE_STATE,
    payload: payload,
  };
}

export function InitCurrentCataloguePayloadAction(payload) {
  return {
    type: PublisherActionTypes.SET_CURRENT_CATALOGUEID_PAYLOAD,
    payload: payload,
  };
}

export function SetCurrentCatalogueId(payload) {
  return {
    type: PublisherActionTypes.SET_CURRENT_CATALOGUE_ID,
    payload: payload,
  };
}

export function GetCatalogueListSuccessAction(payload) {
  return {
    type: PublisherActionTypes.GET_CATALOGUE_LIST,
    payload: payload,
  };
}

export function GetCurrentCatalogueSubjectSuccessAction(payload) {
  return {
    type: PublisherActionTypes.GET_CURRENT_CATALOGUE_SUBJECTS,
    payload: payload,
  };
}

export function GetCatalogueSubjectSuccessAction(payload) {
  return {
    type: PublisherActionTypes.GET_CATALOGUE_SUBJECTS,
    payload: payload,
  };
}

export function GetCatalogueDataByIdSuccessAction(payload) {
  return {
    type: PublisherActionTypes.GET_CURRENT_CATALOGUE_ID_DATA,
    payload: payload,
  };
}

export function GetCategoryListSuccessAction(payload) {
  return {
    type: PublisherActionTypes.GET_CATEGORY_LIST,
    payload: payload,
  };
}

export function ModifyCurrentCatalogueInfo(payload) {
  return {
    type: PublisherActionTypes.MODIFY_CATALOGUE_CATALOGUEINFO,
    payload: payload,
  };
}

export function ModifyCurrentCatalogueTheme(payload) {
  return {
    type: PublisherActionTypes.MODIFY_CATALOGUE_THEME,
    payload: payload,
  };
}
export function ModifyCurrentCataloguePublisher(payload) {
  return {
    type: PublisherActionTypes.MODIFY_CATALOGUE_PUBLISHER,
    payload: payload,
  };
}

export function AddStepperError(payload) {
  return {
    type: PublisherActionTypes.ADD_STEPPER_ERRORS,
    payload: payload,
  };
}

export function ModifyStakeHolders(payload) {
  return {
    type: PublisherActionTypes.MODIFY_CURRENT_CATALOGUE_STAKEHOLDERS,
    payload: payload,
  };
}

export function ModifyCatalogueSubmit() {
  return {
    type: PublisherActionTypes.MODIFY_CURRENT_CATALOGUE_FORM_SUBMIT,
  };
}
export function ModifyCurrentStoreListingFreeTrialStatusAction(payload) {
  return {
    type: PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_FREE_TRIAL_STATUS,
    payload: payload,
  };
}

export function ModifyCurrentStoreListingHallTicketCollectionDetailsAction(payload) {
  return {
    type: PublisherActionTypes.MODIFY_CURRENT_STORE_LISTING_HALL_TICKET_COLLECTION_DETAILS,
    payload: payload,
  };
}

export function GetAllFeaturesSuccessAction(payload) {
  return {
    type: PublisherActionTypes.GET_ALL_FEATURES,
    payload: payload,
  };
}
// ASYNC actions ************************************************************************************

// [Ots Manager]

export function GetOtsCatalogueListAction(url, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      let response = await getData(url);
      dispatch(GetOtsCatalogueListSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

const getAllBatchesSuccess = payload => ({
  type: PublisherActionTypes.GET_ALL_LIVE_BATCHES,
  payload,
});

export const getAllBatches = () => {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const response = await getData(
        getAPIEndpoints().getBatchInfoByStatus,
        generateUserInfoHeader(getDataFromSessionStorage('userRoles'))
      );
      dispatch(getAllBatchesSuccess(response));
      dispatch(ApiCallSuccessAction(handlePlainApiSuccess(response)));
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err)));
    }
  };
};

const getBatchesPaginatedSuccess = payload => ({
  type: PublisherActionTypes.GET_BATCHES_PAGINATED,
  payload,
});

// batchIds, when passed, resolves those specific batches (e.g. to label already-selected
// batches on edit) and ignores query/page/size — see BatchController's "resolve mode".
export const getBatchesPaginated = ({
  page = 0,
  size = 20,
  query = '',
  batchType,
  batchIds,
} = {}) => {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      const params = new URLSearchParams({ page, size });
      if (query) params.append('query', query);
      if (batchType) params.append('batchType', batchType);
      (batchIds || []).forEach(id => params.append('batchIds', id));
      const url = `${getAPIEndpoints().getBatchInfoByStatusPagination}?${params.toString()}`;
      const response = await getData(
        url,
        generateUserInfoHeader(getDataFromSessionStorage('userRoles'))
      );
      dispatch(getBatchesPaginatedSuccess(response));
      dispatch(ApiCallSuccessAction(handlePlainApiSuccess(response)));
      return response?.data?.data;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err)));
      return null;
    }
  };
};

export function GetOtsSubscriptionListingByIDAction(url, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      let response = await getData(url);
      dispatch(InitOtsSubscriptionsListAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function UpdateOtsSubscriptionByIDAction(url, body, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      let response = await putData(url, body, headers);
      dispatch(UpdateOtsSubscriptionSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

// [Store Manager]
// Recommended Courses

export const getAllRecommendedCourses = id => async dispatch => {
  try {
    dispatch(ApiCallInProgress());
    const response = await getData(getAPIEndpoints().getAllRecommendedCourses.replace('{id}', id));
    dispatch(saveAllRecommendedCourses(response.data));
    dispatch(ApiCallSuccessAction(handleApiSuccess(response)));
  } catch (error) {
    dispatch(ApiCallFailedAction(handleApiError(error)));
  }
};

const saveAllRecommendedCourses = payload => ({
  type: PublisherActionTypes.SAVE_ALL_RECOMMENDED_COURSES,
  payload,
});

export const saveRecommendedCourses = payload => ({
  type: PublisherActionTypes.SAVE_RECOMMENDED_COURSES,
  payload,
});

export function UpdateSubCategoryOrderAction(url, body, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      let response = await putData(url, body, headers);
      dispatch(UpdateSubCategoryOrderSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function UpdateStoreListingOrderAction(url, body, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      let response = await putData(url, body, headers);
      dispatch(UpdateStoreListingOrderSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function UpdateCategoryOrderAction(url, body, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      let response = await putData(url, body, headers);
      dispatch(UpdateCategoryOrderSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function CreateStoreListingAction(url, body, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      let response = await postData(url, body, headers);
      dispatch(CreateStoreListingSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function UpdateStoreListingAction(url, body, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      let response = await putData(url, body, headers);
      dispatch(UpdateStoreListingSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function GetAllStoreListingAction(url, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      let response = await getData(url);
      dispatch(GetAllStoreListingSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function DeleteAStoreListingAction(url, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      let response = await deleteData(url);
      dispatch(DeleteAStoreListingSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function UpdateStoreListingStatusAction(url, body, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      let response = await putData(url, body, headers);
      dispatch(UpdateStoreListingStatusSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function GetStoreListingInfo(url) {
  return getData(url)
    .then(res => res?.data ?? {})
    .catch(err => err);
}

export function GetStoreListingByIDAction(url, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      let response = await getData(url);
      dispatch(GetStoreListingByIDSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

// [Catalogue Manager]

export function UpdateCatalogueStatusAction(url, body, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      let response = await putData(url, body, headers);
      dispatch(UpdateCatalogueStatusSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function AddCategoryAction(url, body, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      let response = await postData(url, body, headers);
      dispatch(AddCategorySuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function UpdateCategoryAction(url, body, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      let response = await putData(url, body, headers);
      dispatch(UpdateCatagorySuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function DeleteCategoryByIdAction(url, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      let response = await deleteData(url, headers);
      dispatch(DeleteCategoryByIdSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function DeleteCatalogueByIdAction(url, headers, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      let response = await deleteData(url, headers);
      dispatch(DeleteCatalogueByIdSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function GetCatalogueListAction(url, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      let response = await getData(url);
      dispatch(GetCatalogueListSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function GetCurrentCatalogueSubjectAction(url, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      let response = await getData(url);
      dispatch(GetCurrentCatalogueSubjectSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function GetCatalogueSubjectAction(url, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      let response = await getData(url);
      dispatch(GetCatalogueSubjectSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function GetCatalogueDataByIdAction(url, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      let response = await getData(url);
      dispatch(GetCatalogueDataByIdSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function GetCategoryListAction(url, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      let response = await getData(url);
      dispatch(GetCategoryListSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function CreateCatalogueAction(url, payload, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      let response = await postData(url, payload);
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function ModifyCatalogueAction(url, payload, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      let response = await putData(url, payload);
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function GetFeaturesList(url, metaData) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      let response = await getData(url);
      dispatch(GetAllFeaturesSuccessAction(response));
      dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
      return false;
    }
  };
}

export function UpdateSyllabusPdf(payload, message) {
  return async dispatch => {
    try {
      dispatch(ApiCallInProgress());
      dispatch(ModifyCurrentStoreListingProgramsAction(payload));
      dispatch(ApiCallSuccessAction(handleApiSuccess({ data: { message } }, {})));
      return true;
    } catch (err) {
      dispatch(ApiCallFailedAction(handleApiError(err, {})));
      return false;
    }
  };
}
